class FormsPlaceHolderType {
  Email() {
    return 0;
  }
  Password() {
    return 1;
  }
  Search() {
    return 2;
  }
  Reason() {
    return 3;
  }
  RejectActivation() {
    return 4;
  }
  SendSms() {
    return 5;
  }
}
export default new FormsPlaceHolderType();
